export default "__VITE_ASSET__BPJtJyhk__"